// extracted by mini-css-extract-plugin
export default {"drag":"styles_drag__3eQqI","icon":"styles_icon__J8C9U"};